import { TaskTemplateAssigneeRole } from "@common/types/taskTemplateAssigneeRole";

/**
 * Derived from template *tasks* only (never stored on schedules/occurrences).
 * Same shape as `CloseTemplateWithStats` estimate fields from listCloseTemplates.
 */
export interface TemplateEstimateStats {
    totalEstimatedTime: number;
    estimatedTimeByRole: Partial<Record<TaskTemplateAssigneeRole, number>>;
}

export const EMPTY_TEMPLATE_ESTIMATE_STATS: TemplateEstimateStats = {
    totalEstimatedTime: 0,
    estimatedTimeByRole: {},
};

export const ROLE_FIELD_TO_ASSIGNEE_ROLE: Record<
    "preparerId" | "reviewerId" | "managerId" | "clientId",
    TaskTemplateAssigneeRole
> = {
    preparerId: TaskTemplateAssigneeRole.PREPARER,
    reviewerId: TaskTemplateAssigneeRole.REVIEWER,
    managerId: TaskTemplateAssigneeRole.MANAGER,
    clientId: TaskTemplateAssigneeRole.CLIENT,
};

export function getRoleEstimatedMinutes(
    stats: TemplateEstimateStats | undefined,
    role: TaskTemplateAssigneeRole,
): number {
    return stats?.estimatedTimeByRole[role] ?? 0;
}
